import React from "react";

export default function ExitIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3100_709)">
        <path
          d="M16.625 0H4.75C4.43506 0 4.13301 0.125111 3.91031 0.347811C3.68761 0.57051 3.5625 0.872555 3.5625 1.1875V3.5625H5.9375V2.375H15.4375V16.625H5.9375V15.4375H3.5625V17.8125C3.5625 18.1274 3.68761 18.4295 3.91031 18.6522C4.13301 18.8749 4.43506 19 4.75 19H16.625C16.9399 19 17.242 18.8749 17.4647 18.6522C17.6874 18.4295 17.8125 18.1274 17.8125 17.8125V1.1875C17.8125 0.872555 17.6874 0.57051 17.4647 0.347811C17.242 0.125111 16.9399 0 16.625 0Z"
          fill="white"
        />
        <path
          d="M5.79381 12.223L7.47294 13.9021L11.875 9.50002L7.47294 5.09796L5.79381 6.77709L7.32925 8.31252H1.1875V10.6875H7.32925L5.79381 12.223Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3100_709">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
